import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import Datetime from "react-datetime";
import { Link } from 'react-router-dom'

import PropTypes from "prop-types";

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Icon from "@material-ui/core/Icon";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Group from "@material-ui/icons/Group";
import Fingerprint from "@material-ui/icons/Fingerprint";
import Lock from "@material-ui/icons/Lock";
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";
import Check from "@material-ui/icons/Check";
import LocalShipping from "@material-ui/icons/LocalShipping";
import Dashboard from "@material-ui/icons/Dashboard";
import Search from "@material-ui/icons/Search";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import NavPills from "components/NavPills/NavPills.jsx";

import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

import { startSetOrdersList } from "store/actions/ordersActions"

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: []
    };
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleSelectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
  }
  handlePickUpDateChange = (pickUpDate) => {
    //console.log(pickUpDate._d)
    if (pickUpDate) {
      this.setState(() => ({ pickUpDate: pickUpDate._d }))
    }
  }

  handleToggle(value) {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({
      checked: newChecked
    });
  }
  loadData = (uid) => {
    let ordersData = this.props.orders.dataRows.map((prop, key) => {
      let colObj = { ...prop }
      const ID = colObj.id
      const shipperID = colObj.uid
      const status = colObj.status
      // const volUID = colObj.volUID
      // const username = colObj.username
      // Load Data for Summary Cards and add buttons     
      //console.log(colObj)
      //if (colObj.uid === uid ) {
      return {
        ...colObj,
        // status: (<span style={{ color: "red" }}>assigned</span>),
        //id: key,
        actions: (
          <Button
            color="primary"
            fullWidth
            onClick={
              () => this.handleClickOpen("updateDispatchModal",
                ID,
                shipperID,
                status,
              )}
          >QUOTE</Button>)
      }
      //} 
    })

    this.setState({
      ordersData,
      dataLoaded: true
    })
  }
  render() {
    const { classes, orders } = this.props;
    if (orders) {
      //console.log(assessments.dataLoaded)
      if (orders.dataLoaded
        && !this.state.dataLoaded) {
        //console.log(authUser.uid)
        this.loadData()
        // console.log(user)
        // console.log(user.levelUpdatedAt.toDate())
        // console.log(moment(user.levelUpdatedAt.toDate()).format('MM-DD-YYYY'))  
      }
    }

    const shippingModes = ["", "Full Truckload", "LTL"]
    const trailerTypes = ["", "Dry Van", "Reefer"]
    const sortOptions = ["", "Origin City (A-Z)", "Age (newest)"]
    console.log(this.state)
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <NavPills
              color="primary"
              alignCenter
              tabs={[
                {
                  tabButton: "Search Loads",
                  tabIcon: Dashboard,
                  tabContent: (
                    <div>
                      <div style={{ width: "100%", margin: "0 auto", marginTop: "-20px" }}>
                        {/*<Search style={{ color: "#fff", marginBottom: "-8px", marginRight: "10px" }} className={classes.headerLinksSvg + " " + classes.searchIcon} />*/}
                        <GridContainer>
                          <GridItem xs={12}>
                            <CustomInput
                              formControlProps={{
                                className: classes.top + " " + classes.search,
                              }}
                              id="query"
                              inputProps={{
                                placeholder: "Origin Zone, State, City or ZIP",
                                onChange: (event) => this.handleChange(event),
                                inputProps: {
                                  "aria-label": "Search",
                                  className: classes.searchInput
                                }
                              }}
                            />
                          </GridItem>
                        </GridContainer>
                      </div>
                      <div style={{ width: "100%", margin: "0 auto", marginTop: "-30px" }}>

                        <GridContainer>
                          <GridItem xs={12}>
                            <CustomInput
                              formControlProps={{
                                className: classes.top + " " + classes.search,
                              }}
                              id="query"
                              inputProps={{
                                placeholder: "Destination Zone, State, City or ZIP",
                                onChange: (event) => this.handleChange(event),
                                inputProps: {
                                  "aria-label": "Search",
                                  className: classes.searchInput
                                }
                              }}
                            />
                          </GridItem>
                        </GridContainer>
                        </div>
                        <div style={{ width: "100%", margin: "0 auto", marginTop: "-30px" }}>

                        <Datetime
                  selected={this.state.pickUpDate}
                  onChange={this.handlePickUpDateChange}
                  timeFormat={true}
                  isValidDate={this.valid}
                  renderInput={(dateInputProps, open, close) => (
                    <CustomInput
                      inputProps={{ ...dateInputProps, id: 'pickUpDate', name: 'pickUpDate', required: true, }}
                      onBlur={close}
                      onFocus={open}
                      labelText="Pickup Date"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  )}
                />
                      </div>
                      
                      {this.state.ordersData && this.state.ordersData.map(order => {
                return (
                  <div>
                    <Card style={{background: "#0084b8", borderRadius: "5px"}}>
                  <Link to={{
                    pathname: `/order/${order.id}`,
                    state: { dataLoaded: false }
                  }}>
                    <CardHeader>
                    <h5 style={{color: "white"}}><b>{order.origin} -> {order.destination}</b>  </h5>
                    </CardHeader>
                        </Link>   
                    <CardBody>
                                           
                    </CardBody>

                  </Card>     
                  </div>
                    )
            })}

                      {/*<ReactTable
                        data={this.state.ordersData}
                        filterable
                        columns={this.props.orders.columns}
                        defaultPageSize={10}
                        defaultSorted={[
                          {
                          }
                        ]}
                        //showPaginationTop
                        showPaginationBottom
                        style={{
                          color: "#FFF"
                        }}
                        className="-striped -highlight"
                      />*/}

                    </div>
                  )
                },
                {
                  tabButton: "Search Trucks",
                  tabIcon: LocalShipping,
                  tabContent: (
                    <span>
                      <div style={{ width: "95%", margin: "0 auto", marginTop: "-10px" }}>
                        <Search style={{ color: "#fff", marginBottom: "-8px", marginRight: "10px" }} className={classes.headerLinksSvg + " " + classes.searchIcon} />

                        <CustomInput
                          formControlProps={{
                            className: classes.top + " " + classes.search,
                            style: { width: "85%" }
                          }}
                          id="query"
                          inputProps={{
                            placeholder: "Search...",
                            onChange: (event) => this.handleChange(event),
                            inputProps: {
                              "aria-label": "Search",
                              className: classes.searchInput
                            }
                          }}
                        />

                      </div>

                    </span>
                  )
                }
              ]}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

HomePage.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
  // console.log(state.orders.pendingOrders)
  return {
    orders: state.orders.orders
  }
}

const mapDispatchToProps = (dispatch) => {
  //console.log(state)
  return {
    startSetOrdersList: dispatch(startSetOrdersList())
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(registerPageStyle)
)(HomePage);


// WEBPACK FOOTER //
// ./src/views/Pages/HomePage.jsx